import React from "react";
import { partnerRows } from "../mock";

const MarqueeRow = ({ partners, reverse = false, duration = 40 }) => {
  const items = [...partners, ...partners, ...partners];
  return (
    <div className="overflow-hidden relative py-4">
      <div
        className={`flex items-center gap-16 w-max ${reverse ? "animate-marquee-reverse" : "animate-marquee"}`}
        style={{ animationDuration: `${duration}s` }}
      >
        {items.map((p, i) => (
          <div key={`${p.name}-${i}`} className="flex-shrink-0 h-10 flex items-center">
            <img
              src={p.logo}
              alt={p.name}
              loading="lazy"
              className="h-8 w-auto max-w-[130px] object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

const Partners = () => (
  <section className="bg-white py-20 lg:py-24 overflow-hidden" data-testid="partners-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 text-center mb-12">
      <h2 className="text-4xl lg:text-[44px] font-bold text-gray-900" style={{ fontFamily: "Archivo, sans-serif" }}>
        Our Partner Ecosystem
      </h2>
      <p className="text-gray-500 mt-3 text-lg">United by Technology</p>
    </div>
    <div className="space-y-2">
      {partnerRows.map((row, i) => (
        <MarqueeRow key={i} partners={row} reverse={i % 2 === 1} duration={42 + i * 6} />
      ))}
    </div>
  </section>
);

export default Partners;
